import { include } from 'named-urls';

export default {
  dashboard: {
    home: '/home/',
    notifications: include('/inbox/', {
      category: ':category/',
    }),
    tasks: include('/actions/', {
      all: 'all/',
      my: 'my/',
      list: 'tasks/',
      audits: 'audits/',
      acknowledgements: 'acknowledgements/',
      risks: 'risks/',
      riskAction: 'risks/:actionId/',
      details: ':taskId/',
      scheduleInstance: 'audits/schedule/:scheduleId/instance/:instanceId/',
    }),
    schedules: include('/schedules/', {
      details: ':scheduleId/',
      new: 'new/',
    }),
    alarms: include('/lone-working/', {
      red: 'alarms/',
      amber: 'timed-alerts/',
      escalationProfiles: include('alarm-response-profiles/', {
        main: '',
        details: ':escalationProfileId/',
      }),
      details: 'alarms/:alarmId/',
      manage: 'manage/',
      devices: include('devices/', {
        details: ':deviceId/',
      }),
      activityMap: 'map/',
      reports: include('usage/', {}),
      reporting: include('reporting/', {
        details: ':reportingType/',
      }),
    }),
    audits: include('/audits/', {
      forms: include('forms/', { details: ':formId/' }),
      templates: include('templates/', { details: ':templateId/' }),
      draft: include('draft/', { details: ':draftId/' }),
      // Legacy: the workflows-api record's tasks list. `relatedActions` is the entity-path one.
      relatedTasks: 'related/tasks/:entityId/',
      relatedActions: 'related/actions/:entityId/',
      relatedSites: 'related/sites/:entityId/',
      relatedAssets: 'related/assets/:entityId/',
      relatedContacts: 'related/contacts/:entityId/',
      relatedEvents: 'related/events/:entityId/',
      relatedRiskAssessments: 'related/riskAssessments/:entityId/',
      relatedDocuments: 'related/documents/:entityId/',
      relatedRisks: 'related/risks/:entityId/',
    }),
    settings: include('/settings/', {
      security: 'security/',
      notifications: 'notifications/',
      preferences: 'preferences/',
      users: include('users/', {
        details: ':userId/',
      }),
      userFields: 'user-fields/',
      organisationStructure: 'organisation-structure/',
      groups: include('groups/', {
        new: 'new/',
        details: ':groupId/',
      }),
      teams: include('teams/', {
        new: 'new/',
        details: ':teamId/',
      }),
      companySettings: 'company-settings/',
      licenses: 'licenses/',
      objects: include('objects/', {
        details: include(':moduleName/', {
          fieldManager: 'field-manager/',
          layoutEditor: 'layout-editor/',
          formBuilder: include('form-builder/', { details: ':formId/' }),
          safetyMetrics: 'safety-metrics/',
          assignmentRules: 'assignment-rules/',
          pipelines: include('pipelines/', { details: ':pipelineId/' }),
        }),
      }),
    }),
    moreApps: '/more/',
    analytics: include('/analytics/', {
      details: ':dashboardId/',
    }),
    disableFeature: include('/disable-feature/', {
      details: ':featureId/',
    }),
    sites: include('/sites/', {
      details: ':entityId/',
      relatedActions: 'related/actions/:entityId/',
      relatedAudits: 'related/audits/:entityId/',
      relatedSites: 'related/sites/:entityId/',
      relatedAssets: 'related/assets/:entityId/',
      relatedEvents: 'related/events/:entityId/',
      relatedContacts: 'related/contacts/:entityId/',
      relatedRiskAssessments: 'related/riskAssessments/:entityId/',
      relatedDocuments: 'related/documents/:entityId/',
      relatedRisks: 'related/risks/:entityId/',
    }),
    assets: include('/assets/', {
      details: ':entityId/',
      relatedActions: 'related/actions/:entityId/',
      relatedAudits: 'related/audits/:entityId/',
      relatedSites: 'related/sites/:entityId/',
      relatedAssets: 'related/assets/:entityId/',
      relatedEvents: 'related/events/:entityId/',
      relatedContacts: 'related/contacts/:entityId/',
      relatedRiskAssessments: 'related/riskAssessments/:entityId/',
      relatedDocuments: 'related/documents/:entityId/',
      relatedRisks: 'related/risks/:entityId/',
    }),
    contacts: include('/contacts/', {
      details: ':entityId/',
      relatedActions: 'related/actions/:entityId/',
      relatedSites: 'related/sites/:entityId/',
      relatedAssets: 'related/assets/:entityId/',
      relatedEvents: 'related/events/:entityId/',
      relatedContacts: 'related/contacts/:entityId/',
      relatedAudits: 'related/audits/:entityId/',
      relatedRiskAssessments: 'related/riskAssessments/:entityId/',
      relatedDocuments: 'related/documents/:entityId/',
      relatedRisks: 'related/risks/:entityId/',
    }),
    riskAssessments: include('/riskAssessments/', {
      details: ':entityId/',
      relatedActions: 'related/actions/:entityId/',
      relatedAudits: 'related/audits/:entityId/',
      relatedSites: 'related/sites/:entityId/',
      relatedAssets: 'related/assets/:entityId/',
      relatedDocuments: 'related/documents/:entityId/',
      relatedRisks: 'related/risks/:entityId/',
    }),
    risks: include('/risks/', {
      riskRegister: 'risk-register/',
      templates: include('templates/', { details: ':templateId/' }),
      controls: 'controls/',
      controlDetails: 'controls/:entityId/',
      hazards: 'hazards/',
      hazardDetails: 'hazards/:entityId/',
      details: ':entityId/',
      relatedActions: 'related/actions/:entityId/',
      relatedAudits: 'related/audits/:entityId/',
      relatedSites: 'related/sites/:entityId/',
      relatedAssets: 'related/assets/:entityId/',
      relatedEvents: 'related/events/:entityId/',
      relatedContacts: 'related/contacts/:entityId/',
      relatedRiskAssessments: 'related/riskAssessments/:entityId/',
      relatedDocuments: 'related/documents/:entityId/',
      relatedRisks: 'related/risks/:entityId/',
    }),
    events: include('/events/', {
      details: ':entityId/',
      relatedActions: 'related/actions/:entityId/',
      relatedAudits: 'related/audits/:entityId/',
      relatedSites: 'related/sites/:entityId/',
      relatedAssets: 'related/assets/:entityId/',
      relatedEvents: 'related/events/:entityId/',
      relatedContacts: 'related/contacts/:entityId/',
      relatedRiskAssessments: 'related/riskAssessments/:entityId/',
      relatedDocuments: 'related/documents/:entityId/',
      relatedRisks: 'related/risks/:entityId/',
      draft: include('draft/', { details: ':draftId/' }),
    }),
    acknowledgements: include('/acknowledgements/', {
      details: ':acknowledgementId/',
    }),
    documents: include('/documents/', {
      details: ':entityId/',
      acknowledgementRequests: include('acknowledgements/', {
        new: 'new/',
        details: ':requestId/',
      }),
      relatedActions: 'related/actions/:entityId/',
      relatedAudits: 'related/audits/:entityId/',
      relatedSites: 'related/sites/:entityId/',
      relatedAssets: 'related/assets/:entityId/',
      relatedEvents: 'related/events/:entityId/',
      relatedContacts: 'related/contacts/:entityId/',
      relatedRiskAssessments: 'related/riskAssessments/:entityId/',
      relatedRisks: 'related/risks/:entityId/',
    }),
  },
  login: '/login/',
  publicForm: include('/publicForm/', { details: ':publicFormId/' }),
  publicFormList: include('/public/organisation/', { details: ':publicUuid/' }),
  shared: include('/shared/', {
    details: ':entityType/:entityId/:shareId/',
  }),
  // Chrome-less recipient acknowledgement page for the mobile app's authenticated WebView.
  embeddedAcknowledgement: include('/embed/acknowledgements/', { details: ':acknowledgementId/' }),
};
